import { render, staticRenderFns } from "./swipeCommissionDetail.vue?vue&type=template&id=5536ef1e&"
import script from "./swipeCommissionDetail.vue?vue&type=script&lang=js&"
export * from "./swipeCommissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./swipeCommissionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports